module.exports = __webpack_public_path__ + "img/Wayfair.838d99ee.jpg";